const PERMISSION_KEY= "company:news_article";
const PAGE_URL = {
    NEWS_ARTICLE_PAGE: "/admin/company/news-article",
    NEWS_ARTICLE_HOME_PAGE: "/admin/company/news-article/home"
}

export {PERMISSION_KEY, PAGE_URL}

